// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://ksqaxdiwtrzavzyuhcwt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtzcWF4ZGl3dHJ6YXZ6eXVoY3d0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYxMzMyNjIsImV4cCI6MjA3MTcwOTI2Mn0.lPHhukNZV-nFBzCXT0uDqwz4YB7HbT72oQ2NikOmJXs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});